// Standard covers ICL IDs (e.g. WI2224-0026) and anything unrecognised.
export enum EditJobIdType {
  STANDARD = 'Standard',
  HURRICANE = 'Hurricane',
  BGR = 'BGR',
  NEXUS = 'Nexus'
}

// Prefixes are listed explicitly: a catch-all letter prefix misfiled Nexus batches as BGR.
const idTypePatterns: Array<[EditJobIdType, RegExp]> = [
  [EditJobIdType.BGR, /^[SG]-\d+$/], // S-8346407, G-123
  [EditJobIdType.NEXUS, /^B-\d+$/], // Nexus batch, e.g. B-1234
  [EditJobIdType.HURRICANE, /^[0-9A-HJKMNP-TV-Z]{26}$/] // ULID (Crockford base32)
]

// The title is free text, so only its first word is taken as the ID.
export function editJobIdType (title: string): EditJobIdType {
  const id = (title ?? '').trim().split(/\s+/)[0].toUpperCase()
  return idTypePatterns.find(([, pattern]) => pattern.test(id))?.[0] ?? EditJobIdType.STANDARD
}
